import { render, staticRenderFns } from "./FortnoxArticles.vue?vue&type=template&id=0d2e15c1"
import script from "./FortnoxArticles.vue?vue&type=script&lang=ts"
export * from "./FortnoxArticles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports